import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { KioskService } from 'src/app/core/services/kiosk.service';
import { DatacapPaymentStatus, DatacapResponse } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapAuthResponse.dto';
import { WebsocketPayTransactionPayload } from 'src/app/shared/models/DTO/PayDevicePaymentRequest.dto';
import { OrderSocketMessage } from 'src/app/shared/models/enums/order-socket-message.enum';

@Component({
	selector: 'app-kiosk-payment-request',
	templateUrl: './kiosk-payment-request.component.html',
	styleUrls: ['../../../kiosk.styles.scss'],
})
export class KioskPaymentRequestComponent implements OnInit, OnDestroy {
	paymentRequest: WebsocketPayTransactionPayload;

	paymentResponseSubscriptpion: Subscription;
	constructor(public kioskService: KioskService, private focuslink: FocuslinkService) {}
	ngOnDestroy(): void {
		this.paymentResponseSubscriptpion.unsubscribe();
	}

	ngOnInit(): void {
		this.subscribeToPaymentResponse();
		this.performPaymentRequest(this.buildPaymentRequest());
	}

	buildPaymentRequest() {
		this.paymentRequest = new WebsocketPayTransactionPayload({
			checkKey: this.kioskService.activeOrder.value.checkKey,
			invoiceNo: this.kioskService.app.moment().unix().toString(),
			transactionAmount: this.kioskService.activeOrder.value.total,
			transactionTip: 0,
			transactionTax: 0,
			payTransactionKey: this.kioskService.app.uuidv4(),
			payTransactionRequestSourceKey: this.kioskService.kioskConfiguration.deviceLicenseKey,
		});
		return this.paymentRequest;
	}

	completePaymentProcess(paymentResponse: DatacapResponse) {
		this.kioskService.paymentResponseAttachToOrder(paymentResponse, 0);
	}

	async performPaymentRequest(paymentRequest) {
		const response = await this.focuslink.paymentRequest(
			this.kioskService.venueService.venueKey,
			this.kioskService.kioskConfiguration.paymentDeviceKey,
			paymentRequest
		);
	}

	subscribeToPaymentResponse() {
		this.paymentResponseSubscriptpion = this.kioskService.deviceService.socket.subscribe((message) => {
			if (
				message?.message === OrderSocketMessage.PAYTRANSACTION &&
				message?.destinationLicenseKey === this.kioskService.kioskConfiguration.deviceLicenseKey
			) {
				console.log(`PayRequestResponse`);
				const datacapResponse = new DatacapResponse(message.payload);
				if (datacapResponse.CmdResponse.CmdStatus === DatacapPaymentStatus.APPROVED) {
					this.completePaymentProcess(datacapResponse);
				}
			}
		});
	}
}
